export default __webpack_public_path__ + "static/media/vp_focus_screen_smartphone.bdd75258.png";